import { Box, Stack } from "@mui/material";
import { BarSize } from "../../components/charts/BarAndLineChart/types";
import { lightScrollbarStyle } from "../../styles/lightScrollbarStyle";
import { MarketSizeBySpend } from "../Workspace/Header/MarketSizeBySpend";
import { MarketSizeByEmployeeChart } from "../Workspace/View/MarketLandscape/MarketSizeByEmployeeChart";
import { MarketSizeByGeographyChart } from "../Workspace/View/MarketLandscape/MarketSizeByGeographyChart";
import { MarketSizeByIndustryChart } from "../Workspace/View/MarketLandscape/MarketSizeByIndustryChart";
import { MarketSizeByRevenueChart } from "../Workspace/View/MarketLandscape/MarketSizeByRevenueChart";

export const ChartsSection: React.FC = () => {
  return (
    <Stack
      gap={1}
      direction="column"
      pt={2}
      width={"100%"}
      height={"100%"}
      pr={1}
      pb={"80px"}
      overflow="auto"
      display="flex"
      px={2}
      boxSizing={"border-box"}
      sx={{
        ...lightScrollbarStyle,
      }}
    >
      <MarketSizeBySpend onlyCards />
      <Box
        display="grid"
        gridTemplateColumns="repeat(auto-fit, minmax(min(500px, 100%), 1fr))"
        gap={1}
      >
        <MarketSizeByGeographyChart
          barSize={BarSize.MEDIUM}
          applyWorkspaceFiltersOnly
        />
        <MarketSizeByIndustryChart
          barSize={BarSize.MEDIUM}
          applyWorkspaceFiltersOnly
        />
        <MarketSizeByRevenueChart
          barSize={BarSize.MEDIUM}
          applyWorkspaceFiltersOnly
        />
        <MarketSizeByEmployeeChart
          barSize={BarSize.MEDIUM}
          applyWorkspaceFiltersOnly
        />
      </Box>
    </Stack>
  );
};
